import React from 'react';

const ManageGuilds = () => {
  return (
    <div className="page-content">
      <h2>Manage Guilds</h2>
      <p>This is a dummy page for managing guilds.</p>
    </div>
  );
};

export default ManageGuilds;
